import { Logger } from 'sletat-common-utils/lib/logger';


export function logVersion(projectName: string, version: string, env: string): void {
    // https://sentry.io/slt/mobile/issues/467239967/
    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log(`%c${projectName}: ${version} (${env})`, 'font-weight:bold;font-size:1.2em;color:#007bbc');
    }
}

export const hotelPageLogger = new Logger({
    messagePrefix: 'hotel page: ',
    isLoggerActive: true
});

export const adsBLockLogger = new Logger({
    messagePrefix: 'Blocking ads service: ',
    isLoggerActive: true
});

export const dataLayerLogger = new Logger({
    messagePrefix: 'dataLayer: ',
    isLoggerActive: true
});
